module.exports = __webpack_public_path__ + "static/img/icon2.a4b3bc7d.svg";